var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerBlackYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 38,
    viewBox: "0 0 26 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6873 35.8297C12.6873 35.8297 24.0978 20.3647 24.0978 13.6449C24.0978 6.92502 18.9899 1.479 12.6873 1.479C6.38471 1.479 1.27686 6.92502 1.27686 13.6449C1.27686 20.3647 12.6873 35.8297 12.6873 35.8297Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6873 35.8297C12.6873 35.8297 24.0978 20.3647 24.0978 13.6449C24.0978 6.92502 18.9899 1.479 12.6873 1.479C6.38471 1.479 1.27686 6.92502 1.27686 13.6449C1.27686 20.3647 12.6873 35.8297 12.6873 35.8297Z",
    fill: "#151515",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3518,
    cy: 12.5711,
    rx: 4.36282,
    ry: 4.65166,
    fill: "#FFF308"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlackYellow);
export default __webpack_public_path__ + "static/media/marker-black-yellow.87b26638b092aedc31a1df7b865ec4c3.svg";
export { ForwardRef as ReactComponent };